export const LogoMark = ({ size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="akis-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#10B981" />
        <stop offset="1" stopColor="#00FF87" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="16" fill="#0D111A" stroke="rgba(255,255,255,0.1)" />
    <path
      d="M12 44c7-18 12-26 18-26 6 0 8 9 10 15 2 7 5 11 12 11"
      stroke="url(#akis-g)"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <circle cx="52" cy="44" r="3.5" fill="#00FF87" />
  </svg>
);

export const Logo = ({ size = 34 }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark size={size} />
    <span className="font-display text-xl font-bold tracking-tight text-slate-50">
      Akış
    </span>
  </span>
);
